const getters = {
  workspace: state => state.workspace.name,
  files: state => state.file.files,
  steps: state => state.workspace.steps,
  timeMapping: state => state.file.timeMapping,
  filterFunction: state => state.file.filterFunction,
  sortPath: state => state.file.sortPath,
  searchFunction: state => state.file.searchFunction,
  currentFile: state => state.file.currentFile,
  currentStep: state => state.workspace.currentStep,
  helpItems: state => state.help.helpItems,
  userId: state => state.user.info.accountId,
  userInfo: state => state.user.info
}

export default getters
